import { render, staticRenderFns } from "./ExcelExport.vue?vue&type=template&id=fafd79f4&scoped=true&"
import script from "./ExcelExport.vue?vue&type=script&lang=js&"
export * from "./ExcelExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafd79f4",
  null
  
)

export default component.exports